import React from 'react';
import './sobre.css';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import parse from "html-react-parser";
import pt from "../../locales/pt.json";

import sobreImg from '../../assets/sobre-img2.webp';

const getYearsSince2017 = () => {
    const currentYear = new Date().getFullYear();
    return currentYear - 2017;
};

const Sobre = () => {
  return (
    <div className="psico__sobre sobre__margin" id="sobre">
      <div className="psico__sobre-content">

        <div className="psico__sobre-img">
          <AnimationOnScroll animateIn="slide-in-left" duration={1.5}>
            <img src={sobreImg} alt="Foto do profissional André Parreira durante um atendimento." />
          </AnimationOnScroll>
        </div>

        <div className="psico__sobre-content__about">

          <div className="psico__sobre-content__about-title">
            <AnimationOnScroll animateIn="slide-in-left" duration={1.5}>
              {/* <h2>Sobre o Dr. André Parreira</h2> */}
              <h2>{parse(pt.sobre.title)}</h2>
            </AnimationOnScroll>
          </div>

          {/* <div className="psico__sobre-content__about-title__broken">
            <AnimationOnScroll animateIn="slide-in-left" duration={1}>
              <h2>Sobre o</h2>
            </AnimationOnScroll>
            <AnimationOnScroll animateIn="slide-in-left" duration={1} delay={700}>
              <h2>Dr. André Parreira</h2>
            </AnimationOnScroll>
          </div> */}

          <div className="psico__sobre-content__about-text">
            <AnimationOnScroll animateIn="slide-in-right" duration={1.5}>
              <div className="texto-aumentado-titulo">
                <p><strong>{parse(pt.sobre.name)}</strong><br />{parse(pt.sobre.crp)}</p>
              </div>

              <p>
                {parse(pt.sobre.content1)}
              </p>

              <p>
                {parse(pt.sobre.content2)}
              </p>

              <p>
                {parse(pt.sobre.content3)}<br />
                {parse(pt.sobre.content4More)} <strong>{getYearsSince2017()} {parse(pt.sobre.content4Years)}</strong><br />
                {parse(pt.sobre.content5)}<br />
                {parse(pt.sobre.content6)}
              </p>

              {/* <p>Aqui, você não encontra apenas escuta. Ofereça um processo terapêutico estruturado, claro e direcionado, com foco em resultados reais — em <strong>VOCÊ!</strong></p> */}

              {/* <p><strong>PORQUE ESCOLHER O MEU TRABALHO?</strong></p>

              <p><strong>✨ Experiência que gera resultados:</strong></p>
              <p className="emoji-line"> */}
                {/* ✔️ <strong>+7.000 horas de prática clínica</strong> em atendimentos individuais e em grupo.<br />
                ✔️ <strong>+7 anos dedicados exclusivamente à prática clínica e 10 anos de trajetória na saúde mental.</strong><br />
                ✔️ <strong>+420 pessoas atendidas</strong>, acompanhando histórias de transformações reais. */}
                {/* ✔️ <strong>+400 Pacientes Transformados.</strong><br />
                ✔️ <strong>+8 anos de Prática Clínica.</strong><br />
                ✔️ <strong>+7.600 horas de Atendimento Psicológico.</strong>
              </p>

              <p><strong>✨ Atendimento de excelência:</strong></p>
              <p className="emoji-line"> */}
                {/* 🔹 Abordagem personalizada, centrada nas suas necessidades.<br />
                🔹 Metodologia estruturada, baseada em evidências, com especialização internacional. */}
                {/* Não ofereço apenas escuta, mas um <strong>Processo Terapêutico direcionado, claro e focado em resultados = VOCÊ!</strong>
              </p> */}

              {/* <p><strong>✨ Depoimentos Reais:</strong></p>
              <p className="emoji-line">
                Veja como a terapia tem transformado a vida de centenas de pessoas — <strong>avaliação 5/5 por quem já viveu essa jornada</strong>.
              </p>

              <p>
                Clique aqui para conferir:
              </p> */}

              {/* <div className="psico__sobre-content__about-text__top5">
                <div className="b_container">
                  <a target="_blank" rel="noreferrer" href="https://www.google.com/search?q=Psic%C3%B3logo+Andr%C3%A9+Parreira">
                    <img src={google5} alt="Avaliação 5 estrelas no Google." />
                  </a>
                </div>
                <div className="img_container">
                  <p></p>
                </div>
              </div>

              <div className="psico__sobre-content__about-text__top5Mobile">
                <div className="b_containerMobile">
                  <a target="_blank" rel="noreferrer" href="https://www.google.com/search?q=Psic%C3%B3logo+Andr%C3%A9+Parreira">
                    <img src={google5} alt="Avaliação 5 estrelas no Google." />
                  </a>
                </div>
              </div> */}
            </AnimationOnScroll>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sobre;
